var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34849 19.0442V15.7228H10.0425V19.0442H14.3671V4.30108H38.5606V19.0442H42.8852V15.7228H48.6753V19.0442H52.9999V11.4217H42.8852V0H10.0425V11.4217H0.0239258V19.0442H4.34849Z",
    fill: "#9BFCB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0492 7.90918H19.7246V15.1254H24.0492V7.90918Z",
    fill: "#9BFCB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2269 7.90918H28.9023V15.1254H33.2269V7.90918Z",
    fill: "#9BFCB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6514 19.0442V35.6989H42.8613V19.0442H38.5367V35.6989H14.3432V19.0442H10.0186V35.6989H4.32457V19.0442H0V40H10.0186H13.8146H40.0743H42.8613H52.976V19.0442H48.6514Z",
    fill: "#4DAAF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.203 19.0442H28.8784V26.2604H33.203V19.0442Z",
    fill: "#4DAAF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0253 19.0442H19.7007V26.2604H24.0253V19.0442Z",
    fill: "#4DAAF8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotelIcon.ace21d3700129cce73fda80c8cdb6352.svg";
export { ForwardRef as ReactComponent };